/* eslint-disable react/display-name */
import React, { useState, useEffect } from 'react'
import { Row, Button } from 'antd'
import { useFormik } from 'formik'
import _ from 'lodash'
import ListScreen from '../../components/ListScreen'
import { api, request } from '../../util/handlerRequestUtil'
import './listAttribute.css'

function ListAttribute(props) {
  const { alert, getMessage } = props
  const formik = useFormik({
    initialValues: {}
  })
  const [modalDelete, setModalDelete] = useState({
    description: getMessage('defaultDeleteDescription'),
    visible: false
  })
  const { values } = formik
  const [data, setData] = useState({})
  const [filters, setFilters] = useState({})
  const { page = 1, pageSize = 10, count = 0, pages = 0 } = data
  const attribute = _.get(data, 'items', []).map(item => {
    return {
      key: item.id,
      ...item
    }
  })
  const columns = [
    {
      title: getMessage('name'),
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: getMessage('attributeitem'),
      dataIndex: 'id',
      key: 'id',
      render: key => (
        <Button onClick={() => props.history.push(`/attributeItem/list?attributeId=${key}`)} type="link">
          {getMessage('viewVariations')}
        </Button>
      )
    }
  ]

  useEffect(() => {
    requests()
  }, [])

  //requests
  async function requests() {
    try {
      await requestData()

      setFilters({})
    } catch (error) {
      console.tron.log(error)
    }
  }

  function onClickEdit(attribute) {
    props.history.push(`/attribute/${attribute.key}`)
  }

  async function onClickDelete(attribute) {
    setModalDelete({
      ...modalDelete,
      title: getMessage('deleteAttributeTitle', attribute.name),
      visible: true,
      onOk: async () => onConfirmDelete(attribute)
    })
  }

  async function onConfirmDelete(attribute) {
    alert.open(getMessage('successAttributeDelete'), 'success')
    await request(api.deleteAttribute(attribute.key))
    setModalDelete({
      ...modalDelete,
      visible: false
    })
    await requestData(values)
  }

  function onClickView(attribute) {
    props.history.push(`/attribute/${attribute.key}?readOnly=true`)
  }

  function onClickDuplicate(attribute) {
    props.history.push(`/attribute/create?duplicate=${attribute.key}`)
  }

  const requestData = (params = {}) =>
    request(
      api.listAttributes({
        ...params,
        include: `
    // cli-include
    `
      })
    ).then(data => setData(data))

  function handleFilter(value) {
    let filters = {}
    //const {} = values
    if (value && value.trim() !== '') {
      filters.name = value
    }
    requestData({
      ...filters
    })
  }

  const onSearch = value => handleFilter(value)

  async function requestPage(page) {
    await requestData({ page: page - 1 })
  }

  const onChangeCreateButton = () => {
    props.history.push('/attribute/create')
  }

  function filtersList() {
    return (
      <Row type="flex" justify="start">
        {/* cli-filters */}
      </Row>
    )
  }
  return (
    <ListScreen
      context={formik}
      columns={columns}
      data={attribute}
      title={getMessage('attribute')}
      titleButtonAdd={getMessage('newAttribute')}
      onSearch={onSearch}
      filtersList={filtersList}
      dataFilters={filters}
      onChange={requestPage}
      onChangeCreateButton={onChangeCreateButton}
      pagination={{
        currentPage: page + 1,
        pages: pages,
        total: count,
        pageSize: pageSize
      }}
      onFilter={handleFilter}
      onClickDelete={onClickDelete}
      modalDelete={modalDelete}
      setModalDelete={setModalDelete}
      onClickEdit={onClickEdit}
      onClickView={onClickView}
      onClickDuplicate={onClickDuplicate}
    />
  )
}

export default ListAttribute
